export class ShiftAccumulationTypeMembership {
	public shiftAccumulationTypeMembershipTypeId;
	public factor;
	
	constructor(obj) {
		this.shiftAccumulationTypeMembershipTypeId = obj.shiftAccumulationTypeMembershipTypeId;
		this.factor = obj.factor;
	}
} 
